import { FC, ReactNode } from 'react';
import Content from './Content';
import styles from './ContentArea.module.css';
import { DisplayOption } from './types/enums';
import { ContentAreaResponse } from './types/shared';

interface IContentArea {
  contentAreaResponse: ContentAreaResponse;
}

const ContentArea: FC<IContentArea> = ({ contentAreaResponse }): ReactNode => {
  const mappaDisplayOptionTillClass = (displayOptions?: string) => {
    switch (displayOptions) {
      case DisplayOption.Full:
        return styles.fullWidth;
      case DisplayOption.TwoThirds:
        return styles.twothirdsWidth;
      case DisplayOption.Half:
        return styles.halfWidth;
      case DisplayOption.OneThird:
        return styles.onethirdWidth;
      default:
        return styles.fullWidth;
    }
  };

  return (
    <div className={styles.contentareacontainer}>
      {contentAreaResponse.items.map((item, index) => (
        <div key={index} className={mappaDisplayOptionTillClass(item.displayOption)}>
          <Content content={item.content} />
        </div>
      ))}
    </div>
  );
};

export default ContentArea;
